import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ServiceRequestedChange } from './service-requested-change.model';

export const loadServiceRequestedChanges = createAction(
  '[ServiceRequestedChange/API] Load ServiceRequestedChanges',
  props<{ serviceRequestedChanges: ServiceRequestedChange[] }>()
);

export const addServiceRequestedChange = createAction(
  '[ServiceRequestedChange/API] Add ServiceRequestedChange',
  props<{ serviceRequestedChange: ServiceRequestedChange }>()
);

export const upsertServiceRequestedChange = createAction(
  '[ServiceRequestedChange/API] Upsert ServiceRequestedChange',
  props<{ serviceRequestedChange: ServiceRequestedChange }>()
);

export const addServiceRequestedChanges = createAction(
  '[ServiceRequestedChange/API] Add ServiceRequestedChanges',
  props<{ serviceRequestedChanges: ServiceRequestedChange[] }>()
);

export const upsertServiceRequestedChanges = createAction(
  '[ServiceRequestedChange/API] Upsert ServiceRequestedChanges',
  props<{ serviceRequestedChanges: ServiceRequestedChange[] }>()
);

export const updateServiceRequestedChange = createAction(
  '[ServiceRequestedChange/API] Update ServiceRequestedChange',
  props<{ serviceRequestedChange: Update<ServiceRequestedChange> }>()
);

export const updateServiceRequestedChanges = createAction(
  '[ServiceRequestedChange/API] Update ServiceRequestedChanges',
  props<{ serviceRequestedChanges: Update<ServiceRequestedChange>[] }>()
);

export const deleteServiceRequestedChange = createAction(
  '[ServiceRequestedChange/API] Delete ServiceRequestedChange',
  props<{ id: string }>()
);

export const deleteServiceRequestedChanges = createAction(
  '[ServiceRequestedChange/API] Delete ServiceRequestedChanges',
  props<{ ids: string[] }>()
);

export const clearServiceRequestedChanges = createAction(
  '[ServiceRequestedChange/API] Clear ServiceRequestedChanges'
);

// CUSTOM
export const getServiceRequestedChanges = createAction(
  '[ServiceRequestedChange/API] get all ServiceRequestedChanges',
  props<{ institutionUniqueId: string }>()
);
